import { BaseService } from '@estee/elc-service';
import { serviceName, version } from './packageInfo';
import { ServiceInitializer } from '@estee/elc-universal-utils';

export class SubscriptionsService extends BaseService {
    constructor(serviceInitializer: ServiceInitializer) {
        super(serviceName, version, serviceInitializer);
    }
}

export default {
    subscriptionsService: 'SUBSCRIPTIONS_SERVICE',
    configStore: 'CONFIG_STORE',
    autoReplenishmentViewController: 'AUTO_REPLENISHMENT_VIEW_CONTROLLER'
};
